import { MovieClip } from '@play-co/timestep-core/ui';
import { Container } from '../../../odie';
import { IEffect } from '../../actions/effects/IEffect';
import { app } from '../../app';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { getMatch2AssetPath } from '../../util/assets';
import { blockViewAssets } from '../../util/blockTools';
import { BarrelBlockEntity } from './BarrelBlockEntity';

export type BarrelBlockEffectOptions = {
  entity: BarrelBlockEntity;
};

export class BarrelBlockEffect implements IEffect {
  private readonly scene: GameScene;
  private readonly options: BarrelBlockEffectOptions;
  private readonly entity: BarrelBlockEntity;

  constructor(scene: GameScene, options: BarrelBlockEffectOptions) {
    this.scene = scene;
    this.options = options;
    this.entity = options.entity;
  }

  public static assets() {
    return blockViewAssets('barrel');
  }

  public async execute() {
    //
  }

  public async playExplodeAnimation() {
    const container = new Container();
    const movieclip = new MovieClip({
      superview: container.view,
      url: getMatch2AssetPath('blocks/barrel/movieclip'),
    });
    const overlay = spawnOverlayEntity(
      this.scene,
      this.entity.c.position.mapPosition,
      this.entity.c.block.props,
      () => container,
      'foreground',
    );
    await movieclip.playAsync('barrell_explode');
    despawnOverlayEntity(this.scene, overlay);
  }

  public async playBreakParticles(mode: 'band' | 'wood' | 'all') {
    const textures: string[] = [];

    if (mode === 'band' || mode === 'all') {
      textures.push(
        getMatch2AssetPath(
          'blocks/barrel/particles/particle_barrell_band_01.png',
        ),
        getMatch2AssetPath(
          'blocks/barrel/particles/particle_barrell_band_02.png',
        ),
      );
    }

    if (mode === 'wood' || mode === 'all') {
      textures.push(
        getMatch2AssetPath(
          'blocks/barrel/particles/particle_barrel_wood_01.png',
        ),
        getMatch2AssetPath(
          'blocks/barrel/particles/particle_barrel_wood_02.png',
        ),
        getMatch2AssetPath(
          'blocks/barrel/particles/particle_barrel_wood_03.png',
        ),
        getMatch2AssetPath(
          'blocks/barrel/particles/particle_barrel_wood_04.png',
        ),
      );
    }

    const particles = app.particles.create({
      textures,
      rate: 0,
      limit: 7,
      emitterDuration: 0,
      duration: 2.5,
      velocity: { x: 0, y: -400 },
      scale: [
        { x: 0.7, y: 0.7 },
        { x: 1.1, y: 1.1 },
      ],
      behaviors: [
        { type: 'explode', magnitude: [100, 300] },
        { type: 'gravity', gravity: { x: 0, y: 2000 } },
        { type: 'scale', to: 0 },
        { type: 'kinematic' },
      ],
    });

    const position = this.entity.c.position.mapPosition.clone();
    const overlay = spawnOverlayEntity(
      this.scene,
      position,
      this.entity.c.block.props,
      () => particles.view,
      'foreground',
    );
    await particles.start();
    despawnOverlayEntity(this.scene, overlay);
  }
}
